import { render, staticRenderFns } from "./WidgetColors.vue?vue&type=template&id=c71f0bd6&scoped=true&"
import script from "./WidgetColors.vue?vue&type=script&lang=js&"
export * from "./WidgetColors.vue?vue&type=script&lang=js&"
import style0 from "./WidgetColors.vue?vue&type=style&index=0&id=c71f0bd6&prod&lang=scss&scoped=true&"
import style1 from "./WidgetColors.vue?vue&type=style&index=1&id=c71f0bd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71f0bd6",
  null
  
)

export default component.exports